module.exports = __webpack_public_path__ + "img/cand.965268e6.svg";